import { render, staticRenderFns } from "./index_GLYF_user_center.vue?vue&type=template&id=998c3eb0&scoped=true"
import script from "./index_GLYF_user_center.vue?vue&type=script&lang=js"
export * from "./index_GLYF_user_center.vue?vue&type=script&lang=js"
import style0 from "./index_GLYF_user_center.vue?vue&type=style&index=0&id=998c3eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998c3eb0",
  null
  
)

export default component.exports